<style scoped>
.d-text {
  font-size: 1.25rem;
  vertical-align: middle;
  color: black !important;
}
.mini-text {
  font-size: 0.9rem;
  vertical-align: middle;
  color: black !important;
  cursor: pointer;
}
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.sub-th2 {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
  min-width: 300px;
}

.th-ellipsis {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>
<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      สรุปแบบสอบถามสุขภาพ
      <v-divider class="mt-1"></v-divider>
    </div>
    <div class="mx-5">
      <v-row>
        <v-col cols="12" sm="12" lg="3" class="mb-n3 mt-n6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหา"
            single-line
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" lg="3" class="mb-n3 mt-n6">
          <v-card-actions>
            <div class="mini-text" @click="export_xls()">
              ดาวน์โหลด
              <v-icon class="mt-2" large>mdi-download</v-icon>
            </div>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-col cols="12" sm="12"
          lg="12" style="text-align: -webkit-right">
        <v-data-table
           dense
            :headers="headers"
            :items="tbl_data"
            class="elevation-1"
            hide-default-header
            :loading="tbl_load"
            :items-per-page="15"
            loading-text="กำลังเรียกข้อมูล..."
            :search="search"
        >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="n-ellipsis" rowspan="2">
                  {{ headers[0].text }}
                </th>
                <th class="sticky-col first-col" rowspan="3">
                  {{ headers[1].text }}
                </th>
                <th class="n-ellipsis" rowspan="3">
                  {{ headers[2].text }}
                </th>
                <th class="n-ellipsis" colspan="18">
                  {{ headers[3].text }}
                </th>
                <th class="n-ellipsis" colspan="19">
                  {{ headers[4].text }}
                </th>
              </tr>
              <tr>
                <th class="sub-th">1.1</th>
                <th class="sub-th">2.1</th>
                <th class="sub-th">3.1</th>
                <th class="sub-th">4.1</th>
                <th class="sub-th">5.1</th>
                <th class="sub-th">6.1</th>
                <th class="sub-th">7.1</th>
                <th class="sub-th">8.1</th>
                <th class="sub-th2">9.1</th>
            
                <th class="sub-th">10.1.1</th>
                <th class="sub-th">10.2.2</th>
                <th class="sub-th">10.3.3</th>
                <th class="sub-th">10.4.4</th>
                <th class="sub-th">10.5.5</th>
                <th class="sub-th">10.6.6</th>
                <th class="sub-th2">11</th>
                <th class="sub-th">1.2</th>
                <th class="sub-th">2.2</th>
                <th class="sub-th">3.2</th>
                <th class="sub-th">4.2</th>
                <th class="sub-th">5.2</th>
                <th class="sub-th">6.2</th>
                <th class="sub-th">7.2</th>
                <th class="sub-th">8.2</th>
                <th class="sub-th2">9.2</th>
                <th class="sub-th">10.2.1</th>
                <th class="sub-th">10.2.2</th>
                <th class="sub-th">10.2.3</th>
                <th class="sub-th">10.2.4</th>
                <th class="sub-th">10.2.5</th>
                <th class="sub-th">10.2.6</th>
                <th class="sub-th">12</th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.CID }}</td>

              <td class="sticky-col first-col th-ellipsis"
                  style="text-align: left !important"
                  >{{ item.FULLNAME }}</td>

              <td>{{ item.P_TYPE }}</td>
              <td>{{ item.INDEXS1_1 }}</td>
              <td>{{ item.INDEXS2_1 }}</td>
              <td>{{ item.INDEXS3_1 }}</td>
              <td>{{ item.INDEXS4_1 }}</td>
              <td>{{ item.INDEXS5_1 }}</td>
              <td>{{ item.INDEXS6_1 }}</td>
              <td>{{ item.INDEXS7_1 }}</td>
              <td>{{ item.INDEXS8_1 }}</td>
              <td >{{ item.OTHER1_1 }}</td>
              <td>{{ item.INDEXS10_1[2] }}</td>
              <td>{{ item.INDEXS10_1[6] }}</td>
              <td>{{ item.INDEXS10_1[10] }}</td>
              <td>{{ item.INDEXS10_1[14] }}</td>
              <td>{{ item.INDEXS10_1[18] }}</td>
              <td>{{ item.INDEXS10_1[22] }}</td>
              <td >{{ JSON.parse(item.INDEXS11).join(", ") }}</td>
              <td>{{ item.INDEXS1_2 }}</td>
              <td>{{ item.INDEXS2_2 }}</td>
              <td>{{ item.INDEXS3_2 }}</td>
              <td>{{ item.INDEXS4_2 }}</td>
              <td>{{ item.INDEXS5_2 }}</td>
              <td>{{ item.INDEXS6_2 }}</td>
              <td>{{ item.INDEXS7_2 }}</td>
              <td>{{ item.INDEXS8_2 }}</td>
              <td>{{ item.OTHER1_2 }}</td>
              <td>{{ item.INDEXS10_2[2] }}</td>
              <td>{{ item.INDEXS10_2[6] }}</td>
              <td>{{ item.INDEXS10_2[10] }}</td>
              <td>{{ item.INDEXS10_2[14] }}</td>
              <td>{{ item.INDEXS10_2[18] }}</td>
              <td>{{ item.INDEXS10_2[22] }}</td>
              <td>{{ item.INDEXS12 }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx";
export default {
  name: "CountActivity",
  components: {},
  data() {
    return {
      tbl_data: [],
      search: "",
      searchGroup: "",
      from_project: "ทั้งหมด",
      ss: null,
      tbl_load: true,
      ss_data: [],
      avg_score: 0,
      pass: 0,
      failed: 0,
      headers: [
        { text: "เลขบัตรประชาชน", value: "CID" },
        { text: "ชื่อ - นามสกุล", value: "FULLNAME" },
        { text: "ประเภทผู้เข้าร่วมโครงการ", value: "P_TYPE" },
        { text: "ปัจจุบัน" },
        { text: "ในอดีตก่อนได้รับการจ้างงาน" },
        { value: "INDEXS1_1" },
        { value: "INDEXS2_1" },
        { value: "INDEXS3_1" },
        { value: "INDEXS4_1" },
        { value: "INDEXS5_1" },
        { value: "INDEXS6_1" },
        { value: "INDEXS7_1" }
      ],
    };
  },
  filters: {},
  async created() {
    await this.api_table_data();
  },

  computed: {},
  methods: {
    api_table_data() {
      this.tbl_load = true;
      this.$token_api

        .get(`/Count-Health`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.tbl_data = result;
            this.tbl_load = false;
          } else {
            this.tbl_load = false;
            this.tbl_data = [];
          }
        })
        .catch((err) => {
          this.tbl_load = false;
          this.tbl_data = [];
        });
    },

    async export_xls() {
      let data = this.tbl_data;
      let xls_json = [];
      if (data.length > 0) {
        let head = await this.$token_api.get(`/Count-Health`);
        const newArray2 = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let obj = {};
          obj["เลขบัตรประชาชน"] = element.CID;
          obj["ชื่อ-นามสกุล"] = element.FULLNAME;
          obj["ประเภทผู้เข้าร่วมโครงการ"] = element.P_TYPE;
          obj["1.ปัจจุบัน สุขภาพโดยทั่วไป ของท่านอยู่ในระดับใด"] = element.INDEXS1_1;
          obj["2.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ"] = element.INDEXS1_2;
          obj["3.ปัจจุบัน ความแข็งแรงทางร่างกาย ของท่านอยู่ในระดับใด"] = element.INDEXS2_1;
          obj["4.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ"] = element.INDEXS2_2;
          obj["5.ปัจจุบัน ความสามารถในการพึ่งพาตนเองในการใช้ชีวิตประจำวัน ของท่านอยู่ในระดับใด"] = element.INDEXS3_1;
          obj["6.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ ความสามารถในการพึ่งพาตนเอง ในการใช้ชีวิตประจำวัน ของท่านอยู่ในระดับใด"] = element.INDEXS3_2;
          obj["7.ปัจจุบัน ความภาคภูมิใจในตัวเอง (ความรู้สึกมีคุณค่าในตัวเอง) ของท่านอยู่ในระดับใด"] = element.INDEXS4_1;
          obj["8.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ ความภาคภูมิใจในตัวเอง (ความรู้สึกมีคุณค่าในตัวเอง) ของท่านอยู่ในระดับใด"] = element.INDEXS4_2;
          obj["9.ปัจจุบัน ความสุขโดยทั่วไป ของท่านอยู่ในระดับใด"] = element.INDEXS5_1;
          obj["10.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ ความสุขโดยทั่วไป ของท่านอยู่ในระดับใด"] = element.INDEXS5_2;
          obj["11.ปัจจุบัน การมีส่วนร่วมกับกิจกรรมในครอบครัวและชุมชน ของท่านอยู่ในระดับใด"] = element.INDEXS6_1;
          obj["12.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ การมีส่วนร่วมกับกิจกรรมในครอบครัวและชุมชน ของท่านอยู่ในระดับใด"] = element.INDEXS6_2;

          obj["13.ปัจจุบัน ความรู้และทักษะในการทำงาน ของท่านอยู่ในระดับใด"] = element.INDEXS7_1;
          obj["14.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ ความรู้และทักษะในการทำงาน ของท่านอยู่ในระดับใด"] = element.INDEXS7_2;
          obj["15.ปัจจุบัน ความรู้ความเข้าใจในการดูแลสุขภาพตัวเอง ของท่านอยู่ในระดับใด"] = element.INDEXS8_1;
          obj["16.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ ความรู้ความเข้าใจในการดูแลสุขภาพตัวเอง ของท่านอยู่ในระดับใด"] = element.INDEXS8_2;

          obj["17.ปัจจุบัน สถานะการเงิน ของท่านอยู่ในระดับใด (หนี้สิน - เงินออม/ทรัพย์สิน)"] = element.OTHER1_1;
          obj["18.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการ สถานะการเงิน ของท่านอยู่ในระดับใด"] = element.OTHER1_2;

          obj["19.ใน 1 เดือนที่ผ่านมาท่านมี พฤติกรรมสุขภาพ เป็นเช่นไร"] = element.INDEXS10_1;
          obj["19_0.ออกกำลังกาย 30 นาที(ปัจจุบัน)"] = element.INDEXS10_1[2];
          obj["19_1.งด/ลดทานหวาน(ปัจจุบัน)"] = element.INDEXS10_1[6];
          obj["19_2.กินผักวันละ 4 กำมือ(ปัจจุบัน)"] = element.INDEXS10_1[10];
          obj["19_3.ดื่มน้ำวันละ 8 แก้ว(ปัจจุบัน)"] = element.INDEXS10_1[14];
          obj["19_4.สูบบุหรี่(ปัจจุบัน)"] = element.INDEXS10_1[18];
          obj["19_5.ดื่มสุรา(ปัจจุบัน)"] = element.INDEXS10_1[22];

          obj["20.ตอนที่ยังไม่เคยได้รับการจ้างงานในโครงการจ้างงานเชิงสังคม ท่านมี พฤติกรรมสุขภาพ เป็นเช่นไร"] = element.INDEXS10_2;
          obj["20_0.ออกกำลังกาย 30 นาที(อดีต)"] = element.INDEXS10_2[2];
          obj["20_1.งด/ลดทานหวาน(อดีต)"] = element.INDEXS10_2[6];
          obj["20_2.กินผักวันละ 4 กำมือ(อดีต)"] = element.INDEXS10_2[10];
          obj["20_3.ดื่มน้ำวันละ 8 แก้ว(อดีต)"] = element.INDEXS10_2[14];
          obj["20_4.สูบบุหรี่(อดีต)"] = element.INDEXS10_2[18];
          obj["20_5.ดื่มสุรา(อดีต)"] = element.INDEXS10_2[22];

          obj["21.ท่านเข้าร่วมโครงการ 70 วัน มหัศจรรย์ของฉัน ซีซั่นใดบ้าง"] = element.INDEXS11;
          obj['22.ท่านคิดว่าโครงการ 70 วัน มหัศจรรย์ มีประโยชน์ในการ "ปรับเปลี่ยนพฤติกรรมสุขภาพ" ของท่าน หรือไม่'] = element.INDEXS12;

          newArray2.push(obj);
        }
        newArray2.forEach((element, i) => {
          xls_json.push(element);
        });

        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `สรุปแบบสอบถามสุขภาพ.xlsx`);
      } else {
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลใหม่อีกครั้ง`,
          timer: 2000,
        });
      }
    },
  },
};
</script>
